import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { IconBack, IconChecked, IconClose } from "../../../icons/svg";
import { language } from "../../../stores/storages/LanguageStorage";
import { Tinode } from "../../../tinode/tinode";

class Language extends React.Component {
   constructor(props) {
      super(props);
      this.handleSetLanguage = this.handleSetLanguage.bind(this);
   }

   handleSetLanguage(lang) {
      language.language = lang;
      language.save();
      window.location.reload();
   }

   render() {
      return (
         <React.Fragment>
            <div className="header">
               <div className="title dialog-flex-center">
                  <div className="icon mr-4" onClick={this.props.handleShowSettingHome}>
                     <IconBack />
                  </div>
                  <FormattedMessage id="dialog_language" defaultMessage={"Language"} />
               </div>
               <div className="icon" onClick={this.props.onClose}><IconClose /></div>
            </div>
            {Tinode.LANGUAGE_SUPPORT.map((item) => {
               return (
                  <div className="border-content-setting" key={item.id} onClick={(_ => this.handleSetLanguage(item.lang))}>
                     <div className="gr-setting" style={{ height: 25 }}>
                        <div className="name dialog-flex-center" >
                           <div className="img mr-4">
                              <img src={item.image} alt={item.name} />
                           </div>
                           {item.name}
                        </div>
                        {language.language === item.lang &&
                           <div className="icon">
                              <IconChecked />
                           </div>
                        }
                     </div>
                  </div>
               );
            })}


         </React.Fragment>
      )
   }
}

export default injectIntl(Language);